var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "#FAFAFA",
    stroke: "#A5BFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 34H29.0312C30.1944 34 31.1406 33.0538 31.1406 31.8906V17.0312H26.2188C25.0556 17.0312 24.1094 16.085 24.1094 14.9219V10H14.9688C13.8056 10 12.8594 10.9462 12.8594 12.1094V31.8906C12.8594 33.0538 13.8056 34 14.9688 34ZM17.7812 19.8906H26.2188C26.6074 19.8906 26.9219 20.2051 26.9219 20.5938C26.9219 20.9824 26.6074 21.2969 26.2188 21.2969H17.7812C17.3926 21.2969 17.0781 20.9824 17.0781 20.5938C17.0781 20.2051 17.3926 19.8906 17.7812 19.8906ZM17.7812 22.7031H26.2188C26.6074 22.7031 26.9219 23.0176 26.9219 23.4062C26.9219 23.7949 26.6074 24.1094 26.2188 24.1094H17.7812C17.3926 24.1094 17.0781 23.7949 17.0781 23.4062C17.0781 23.0176 17.3926 22.7031 17.7812 22.7031ZM17.7812 25.5156H26.2188C26.6074 25.5156 26.9219 25.8301 26.9219 26.2188C26.9219 26.6074 26.6074 26.9219 26.2188 26.9219H17.7812C17.3926 26.9219 17.0781 26.6074 17.0781 26.2188C17.0781 25.8301 17.3926 25.5156 17.7812 25.5156ZM17.7812 28.3281H23.4062C23.7949 28.3281 24.1094 28.6426 24.1094 29.0312C24.1094 29.4199 23.7949 29.7344 23.4062 29.7344H17.7812C17.3926 29.7344 17.0781 29.4199 17.0781 29.0312C17.0781 28.6426 17.3926 28.3281 17.7812 28.3281Z",
    fill: "#1A5298"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2188 15.6251H30.7286L25.5156 10.4121V14.922C25.5156 15.3099 25.8308 15.6251 26.2188 15.6251Z",
    fill: "#1A5298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.a996a7e29199e799598862f10a6bf6ae.svg";
export { ForwardRef as ReactComponent };